
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bxYwf", function(module, exports) {
$parcel$export(module.exports, "default", () => $8681b89af9bd8cee$export$2e2bcd8739ae039);

var $ghphD = parcelRequire("ghphD");


var $b5utg = parcelRequire("b5utg");

function $8681b89af9bd8cee$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var dateLeftStartOfWeek = (0, $ghphD.default)(dirtyDateLeft, options);
    var dateRightStartOfWeek = (0, $ghphD.default)(dirtyDateRight, options);
    return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}

});

parcelRegister("bDxhp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $39XmP = parcelRequire("39XmP");


var $dh538 = parcelRequire("dh538");


var $1eBTN = parcelRequire("1eBTN");

const $341732e6c28c7d3c$export$e63df29a0d863446 = /*#__PURE__*/ (0, $42omo.createContext)({
    containerId: '',
    orgId: '',
    currentUser: undefined,
    analyticsAttributes: {},
    isEditable: undefined,
    isOwnerOrContributor: undefined,
    parentCloudId: undefined,
    parentProduct: undefined
});
const $341732e6c28c7d3c$export$983f1b3296a88282 = ()=>{
    const context = (0, $42omo.useContext)($341732e6c28c7d3c$export$e63df29a0d863446);
    return {
        containerId: context.containerId,
        orgId: context.orgId,
        currentUser: context.currentUser,
        parentProduct: context.parentProduct
    };
};
const $341732e6c28c7d3c$export$2b163c291f77b3f9 = (bridge, url, app, destinationApp)=>{
    const enableCrossMAUUsage = (0, $dh538.fg)('platform_preview_panels_cross_app_interaction');
    const buildUrlWithAnalyticsParams = (0, $39XmP.default)({
        bridge: bridge,
        product: 'townsquare',
        subProduct: app
    });
    return enableCrossMAUUsage && app !== destinationApp ? buildUrlWithAnalyticsParams(url) : url;
};
const $341732e6c28c7d3c$export$d36abdbf11ab2585 = ()=>{
    const context = (0, $42omo.useContext)($341732e6c28c7d3c$export$e63df29a0d863446);
    return context.containerId;
};
const $341732e6c28c7d3c$export$74b3df1a9c1b5a75 = ()=>{
    const context = (0, $42omo.useContext)($341732e6c28c7d3c$export$e63df29a0d863446);
    return context.orgId;
};
const $341732e6c28c7d3c$export$e7e0505785ad2188 = ()=>{
    const context = (0, $42omo.useContext)($341732e6c28c7d3c$export$e63df29a0d863446);
    return (0, $1eBTN.getSiteAri)(context.containerId);
};
const $341732e6c28c7d3c$export$1fd8522aeddaccda = ()=>{
    const context = (0, $42omo.useContext)($341732e6c28c7d3c$export$e63df29a0d863446);
    return context.analyticsAttributes;
};
const $341732e6c28c7d3c$export$6f2ead18de56f0f0 = ()=>{
    const context = (0, $42omo.useContext)($341732e6c28c7d3c$export$e63df29a0d863446);
    // Default to editable as this is the most common case
    return context.isEditable === undefined ? true : context.isEditable;
};
const $341732e6c28c7d3c$export$e07543bf5116993d = ()=>{
    const context = (0, $42omo.useContext)($341732e6c28c7d3c$export$e63df29a0d863446);
    return !!context.isOwnerOrContributor;
};
const $341732e6c28c7d3c$export$e57bd79b746d66f1 = ()=>{
    const context = (0, $42omo.useContext)($341732e6c28c7d3c$export$e63df29a0d863446);
    return context.containerId === context.parentCloudId;
};
const $341732e6c28c7d3c$export$57570b1603cf6adb = ()=>{
    const jiraEnv = document.querySelector('meta[name=ajs-environment]')?.content;
    if (jiraEnv === 'staging') return 'staging';
    if ((0, $dh538.fg)('platform_projects_goals_common_getenv_fix')) {
        const townsquareEnv = document.querySelector('meta[name=env]')?.content;
        if (townsquareEnv?.startsWith('stg')) return 'staging';
    }
    return 'prod';
};
module.exports["ProjectsGoalsContext"] = $341732e6c28c7d3c$export$e63df29a0d863446;
module.exports["useProjectsGoals"] = $341732e6c28c7d3c$export$983f1b3296a88282;
module.exports["useGetCrossProductWrappedUrl"] = $341732e6c28c7d3c$export$2b163c291f77b3f9;
module.exports["useProjectsGoalsContainerId"] = $341732e6c28c7d3c$export$d36abdbf11ab2585;
module.exports["useProjectsGoalsOrgId"] = $341732e6c28c7d3c$export$74b3df1a9c1b5a75;
module.exports["useProjectsGoalsSiteAri"] = $341732e6c28c7d3c$export$e7e0505785ad2188;
module.exports["useAnalyticsAttributes"] = $341732e6c28c7d3c$export$1fd8522aeddaccda;
module.exports["useIsProjectsGoalsEditable"] = $341732e6c28c7d3c$export$6f2ead18de56f0f0;
module.exports["useIsProjectsGoalsOwnerOrContributor"] = $341732e6c28c7d3c$export$e07543bf5116993d;
module.exports["useIsSameSite"] = $341732e6c28c7d3c$export$e57bd79b746d66f1;
module.exports["getEnvironment"] = $341732e6c28c7d3c$export$57570b1603cf6adb;

});

parcelRegister("aCp1o", function(module, exports) {

var $5DUgU = parcelRequire("5DUgU");


var $bDxhp = parcelRequire("bDxhp");

const $339086251c940cfe$export$2ed04b34b7f5fc7f = ({ analyticsAttributes: analyticsAttributes, eventType: eventType, action: action, createAnalyticsEvent: createAnalyticsEvent, actionSubject: actionSubject })=>{
    const baseAnalyticsAttributes = (0, $bDxhp.useAnalyticsAttributes)();
    const analyticsEvent = createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject,
        eventType: eventType,
        tags: [
            'townsquare'
        ],
        attributes: {
            ...analyticsAttributes,
            baseAnalyticsAttributes: baseAnalyticsAttributes
        }
    });
    analyticsEvent.fire('atlas');
};
const $339086251c940cfe$export$3e13615bb023ad8f = ({ analyticsAttributes: analyticsAttributes, eventType: eventType, action: action, createAnalyticsEvent: createAnalyticsEvent, actionSubject: actionSubject })=>{
    const analyticsEvent = createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject,
        eventType: eventType,
        tags: [
            'townsquare'
        ],
        attributes: {
            ...analyticsAttributes
        }
    });
    analyticsEvent.fire('atlas');
};
function $339086251c940cfe$export$1ea3536c4f602870(analyticsClient, subproduct, accountId, orgId, cloudId) {
    analyticsClient.setSubproduct(subproduct);
    if (orgId && orgId !== '') analyticsClient.setOrgInfo(orgId);
    if (cloudId && cloudId !== '') analyticsClient.setTenantInfo((0, $5DUgU.tenantType).CLOUD_ID, cloudId);
    else analyticsClient.setTenantInfo((0, $5DUgU.tenantType).NONE, cloudId);
    if (accountId && accountId !== '') analyticsClient.setUserInfo((0, $5DUgU.userType).ATLASSIAN_ACCOUNT, accountId);
}
module.exports["fireAnalyticEvent"] = $339086251c940cfe$export$3e13615bb023ad8f;
module.exports["setAnalyticsClientInfo"] = $339086251c940cfe$export$1ea3536c4f602870;

});

parcelRegister("bCd2g", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $917iu = parcelRequire("917iu");


var $cFEpk = parcelRequire("cFEpk");


var $9gbhg = parcelRequire("9gbhg");


var $da71s = parcelRequire("da71s");


var $ksiqf = parcelRequire("ksiqf");


var $2uNcU = parcelRequire("2uNcU");

const $1f69f6c3e6f307ad$export$27765aab0dadeddc = {
    DAY: 'DAY',
    MONTH: 'MONTH',
    QUARTER: 'QUARTER',
    INTERVAL: 'INTERVAL'
};
const $1f69f6c3e6f307ad$var$MONTH_THRESHOLD = 31;
const $1f69f6c3e6f307ad$var$DAY_THRESHOLD = 1;
const $1f69f6c3e6f307ad$export$73adc9cbc5981a56 = (dateObj)=>{
    if (dateObj) {
        const dateDiff = (0, $917iu.default)(new Date(dateObj.end), new Date(dateObj.start));
        if (dateDiff < $1f69f6c3e6f307ad$var$DAY_THRESHOLD) return $1f69f6c3e6f307ad$export$27765aab0dadeddc.DAY;
        if (dateDiff <= $1f69f6c3e6f307ad$var$MONTH_THRESHOLD) return $1f69f6c3e6f307ad$export$27765aab0dadeddc.MONTH;
        return $1f69f6c3e6f307ad$export$27765aab0dadeddc.QUARTER;
    }
    // If date is somehow undefined, we'll show quarters picker by default
    return $1f69f6c3e6f307ad$export$27765aab0dadeddc.QUARTER;
};
const $1f69f6c3e6f307ad$var$DEFAULT_FISCAL_YEAR_PREFIX = 'FY';
const $1f69f6c3e6f307ad$export$3a6708e815f1ccd1 = (locale, dateString, placeholder, withTimeScale, intervalDisplayName, fiscalYearPrefix)=>{
    if (!dateString) return placeholder;
    const endDate = (0, $da71s.default)(dateString.end);
    if (!(0, $cFEpk.default)(endDate)) return placeholder;
    if (intervalDisplayName !== undefined) {
        const startDate = (0, $da71s.default)(dateString.start);
        if (!(0, $cFEpk.default)(startDate)) return placeholder;
        return (0, $2uNcU.formatNiceIntervalRangeDate)(fiscalYearPrefix ?? $1f69f6c3e6f307ad$var$DEFAULT_FISCAL_YEAR_PREFIX, intervalDisplayName, startDate, endDate, locale);
    }
    switch($1f69f6c3e6f307ad$export$73adc9cbc5981a56(dateString)){
        case $1f69f6c3e6f307ad$export$27765aab0dadeddc.DAY:
            return (0, $2uNcU.formatNiceDate)(endDate, locale);
        case $1f69f6c3e6f307ad$export$27765aab0dadeddc.QUARTER:
            return (0, $2uNcU.formatNiceQuarterDate)(endDate, locale);
        default:
        case $1f69f6c3e6f307ad$export$27765aab0dadeddc.MONTH:
            return withTimeScale ? (0, $2uNcU.formatNiceMonthDate)(endDate, locale) : (0, $2uNcU.formatMonthOnlyDate)(endDate, locale);
    }
};
function $1f69f6c3e6f307ad$export$b034b69aae1dad2a(interval, displayYear, locale) {
    const startInDisplayYear = new Date(displayYear, interval.startDate.getMonth(), interval.startDate.getDate());
    const endInDisplayYear = new Date(displayYear, interval.endDate.getMonth(), interval.endDate.getDate());
    return {
        start: (0, $2uNcU.formatIsoLocalDate)(startInDisplayYear, locale),
        end: (0, $2uNcU.formatIsoLocalDate)(endInDisplayYear, locale)
    };
}
const $1f69f6c3e6f307ad$export$dcf81686e850fc1a = (props)=>{
    const parsedDate = props.date ? (0, $da71s.default)(props.date) : new Date();
    return {
        initialYear: parsedDate.getFullYear(),
        year: parsedDate.getFullYear(),
        month: parsedDate.getMonth()
    };
};
const $1f69f6c3e6f307ad$export$470b6320f3327b8a = (date)=>{
    if (!date) return undefined;
    const parsedDate = (0, $da71s.default)(date);
    if (!(0, $cFEpk.default)(parsedDate)) return undefined;
    return {
        initialYear: parsedDate.getFullYear(),
        year: parsedDate.getFullYear(),
        month: parsedDate.getMonth()
    };
};
const $1f69f6c3e6f307ad$var$defaultDateLocale = (0, $9gbhg.default);
const $1f69f6c3e6f307ad$var$DateLocaleContext = /*#__PURE__*/ (0, $42omo.createContext)($1f69f6c3e6f307ad$var$defaultDateLocale);
const $1f69f6c3e6f307ad$export$99b2dd0981b0b6d2 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($1f69f6c3e6f307ad$var$DateLocaleContext);
function $1f69f6c3e6f307ad$export$b5a0a52d8148dacc(confidence) {
    if (!confidence) return false;
    return [
        'MONTH',
        'QUARTER',
        'DAY'
    ].includes(confidence);
}
const $1f69f6c3e6f307ad$export$cb14a9963bfc66da = {
    [$1f69f6c3e6f307ad$export$27765aab0dadeddc.DAY]: 100,
    [$1f69f6c3e6f307ad$export$27765aab0dadeddc.MONTH]: 0,
    [$1f69f6c3e6f307ad$export$27765aab0dadeddc.QUARTER]: -50
};
const $1f69f6c3e6f307ad$export$32c50ab22112d6ce = (confidence)=>{
    // I hate JS. The number 0 is a false-y value. So we have to be explicit here for null checking
    if (confidence !== undefined && confidence !== null) {
        if (confidence >= $1f69f6c3e6f307ad$export$cb14a9963bfc66da[$1f69f6c3e6f307ad$export$27765aab0dadeddc.DAY]) return $1f69f6c3e6f307ad$export$27765aab0dadeddc.DAY;
        if (confidence >= $1f69f6c3e6f307ad$export$cb14a9963bfc66da[$1f69f6c3e6f307ad$export$27765aab0dadeddc.MONTH]) return $1f69f6c3e6f307ad$export$27765aab0dadeddc.MONTH;
        return $1f69f6c3e6f307ad$export$27765aab0dadeddc.QUARTER;
    } else // If confidence is somehow undefined, we'll show full date just in case
    return $1f69f6c3e6f307ad$export$27765aab0dadeddc.DAY;
};
const $1f69f6c3e6f307ad$export$bbe804fa4e5af3bf = (targetDate)=>{
    if (!targetDate?.date) return undefined;
    if (targetDate.confidence === 'DAY') return {
        start: targetDate.date,
        end: targetDate.date
    };
    if (targetDate.confidence === 'MONTH') return {
        // Threshold for daily view is one day difference
        start: (0, $ksiqf.default)(new Date(targetDate.date), 1).toString(),
        end: targetDate.date
    };
    return {
        // We show the quarter view by default
        start: '',
        end: targetDate.date
    };
};
module.exports["DateRangeScale"] = $1f69f6c3e6f307ad$export$27765aab0dadeddc;
module.exports["getDateRangeScale"] = $1f69f6c3e6f307ad$export$73adc9cbc5981a56;
module.exports["renderDateString"] = $1f69f6c3e6f307ad$export$3a6708e815f1ccd1;
module.exports["intervalToDatePickerValue"] = $1f69f6c3e6f307ad$export$b034b69aae1dad2a;
module.exports["getInitialMonthPickerDate"] = $1f69f6c3e6f307ad$export$dcf81686e850fc1a;
module.exports["getMonthPickerDate"] = $1f69f6c3e6f307ad$export$470b6320f3327b8a;
module.exports["useDateLocale"] = $1f69f6c3e6f307ad$export$99b2dd0981b0b6d2;
module.exports["isValidConfidence"] = $1f69f6c3e6f307ad$export$b5a0a52d8148dacc;
module.exports["getFuzzyScale"] = $1f69f6c3e6f307ad$export$32c50ab22112d6ce;
module.exports["convertTargetDateToRange"] = $1f69f6c3e6f307ad$export$bbe804fa4e5af3bf;

});

parcelRegister("2uNcU", function(module, exports) {

var $3Vbz9 = parcelRequire("3Vbz9");


var $5eayg = parcelRequire("5eayg");


var $bzSU8 = parcelRequire("bzSU8");


var $fakaf = parcelRequire("fakaf");


var $9tcaE = parcelRequire("9tcaE");


var $cPLkE = parcelRequire("cPLkE");


var $aXWIB = parcelRequire("aXWIB");


var $4jeQc = parcelRequire("4jeQc");


var $4pirX = parcelRequire("4pirX");


var $cn4qU = parcelRequire("cn4qU");

const $eccb9ac84cb9c146$export$2e9241a0bdf6c8b8 = (from, to, locale, separator = '-')=>{
    if ((0, $fakaf.default)(from, to)) {
        const fromDisplay = (0, $4pirX.format)(from, (0, $bzSU8.default)(from, to) ? (0, $4jeQc.SAME_MONTH_FORMAT) : (0, $4jeQc.SAME_YEAR_FORMAT), {
            locale: locale
        });
        const toDisplay = $eccb9ac84cb9c146$export$9b0e8a03930c4b1e(to, locale);
        return `${fromDisplay}${separator}${toDisplay}`;
    } else {
        const fromDisplay = (0, $4pirX.format)(from, (0, $4jeQc.DIFF_YEAR_FORMAT), {
            locale: locale
        });
        const toDisplay = (0, $4pirX.format)(to, (0, $4jeQc.DIFF_YEAR_FORMAT), {
            locale: locale
        });
        return `${fromDisplay}${separator}${toDisplay}`;
    }
};
const $eccb9ac84cb9c146$export$6af622c1a7099d35 = (date, _locale, noDash)=>{
    return (0, $4pirX.format)(date, noDash ? (0, $4jeQc.DIFF_YEAR_FORMAT) : (0, $4jeQc.FULL_NICE_FORMAT));
};
const $eccb9ac84cb9c146$export$cec1db3fd4087308 = (date, locale)=>$eccb9ac84cb9c146$export$fb3485f471c77284(date, (0, $9tcaE.default)(date) ? (0, $4jeQc.MONTH_ONLY_FORMAT) : (0, $4jeQc.MONTH_ONLY_FORMAT_DIFF_YEAR), locale);
const $eccb9ac84cb9c146$export$446ec9bc291d6ba4 = (date, locale)=>$eccb9ac84cb9c146$export$fb3485f471c77284(date, (0, $4jeQc.MONTH_WITH_YEAR), locale);
const $eccb9ac84cb9c146$export$f18cba231431b904 = (fiscalYearPrefix, intervalName, date, locale)=>{
    const year = $eccb9ac84cb9c146$export$fb3485f471c77284(date, 'yy', locale);
    return `${intervalName} ${fiscalYearPrefix}${year}`;
};
const $eccb9ac84cb9c146$export$a759ab4dd7c186ad = (fiscalYearPrefix, intervalDisplayName, startDate, endDate, locale)=>{
    const startYear = $eccb9ac84cb9c146$export$fb3485f471c77284(startDate, 'yy', locale);
    const endYear = $eccb9ac84cb9c146$export$fb3485f471c77284(endDate, 'yy', locale);
    const rangeParts = intervalDisplayName.split(" \u2013 ");
    if (rangeParts.length === 2) {
        if (startYear === endYear) return `${intervalDisplayName} ${fiscalYearPrefix}${startYear}`;
        return `${rangeParts[0]} ${fiscalYearPrefix}${startYear} \u{2013} ${rangeParts[1]} ${fiscalYearPrefix}${endYear}`;
    }
    return $eccb9ac84cb9c146$export$f18cba231431b904(fiscalYearPrefix, intervalDisplayName, startDate, locale);
};
const $eccb9ac84cb9c146$export$65cbe7f37a8de928 = (date, locale)=>`${$eccb9ac84cb9c146$export$fb3485f471c77284((0, $cPLkE.default)(date), (0, $4jeQc.MONTH_ONLY_FORMAT_SHORT), locale)}-${$eccb9ac84cb9c146$export$fb3485f471c77284((0, $5eayg.default)(date), (0, $9tcaE.default)(date) ? (0, $4jeQc.MONTH_ONLY_FORMAT_SHORT) : (0, $4jeQc.MONTH_ONLY_FORMAT_DIFF_YEAR), locale)}`;
const $eccb9ac84cb9c146$export$aeec403faa363c87 = (date, locale)=>`${$eccb9ac84cb9c146$export$fb3485f471c77284((0, $cPLkE.default)(date), (0, $4jeQc.MONTH_ONLY_FORMAT), locale)}-${$eccb9ac84cb9c146$export$fb3485f471c77284((0, $5eayg.default)(date), (0, $4jeQc.MONTH_WITH_YEAR), locale)}`;
const $eccb9ac84cb9c146$export$7737235a051de40b = (dateString, locale)=>{
    return $eccb9ac84cb9c146$export$9b0e8a03930c4b1e((0, $cn4qU.tzDate)(dateString), locale);
};
const $eccb9ac84cb9c146$export$9b0e8a03930c4b1e = (date, locale)=>$eccb9ac84cb9c146$export$fb3485f471c77284(date, (0, $9tcaE.default)(date) ? (0, $4jeQc.SAME_YEAR_FORMAT) : (0, $4jeQc.DIFF_YEAR_FORMAT), locale);
const $eccb9ac84cb9c146$export$47fbc3e2a5240e18 = (date, locale)=>$eccb9ac84cb9c146$export$fb3485f471c77284(date, (0, $4jeQc.FULL_DATE_FORMAT), locale);
const $eccb9ac84cb9c146$export$fb3485f471c77284 = (date, dateFormat, locale)=>(0, $4pirX.format)(date, dateFormat, {
        locale: locale
    });
const $eccb9ac84cb9c146$export$dcb72c0d0fb82631 = (date, locale)=>$eccb9ac84cb9c146$export$fb3485f471c77284(date, (0, $4jeQc.NICE_DATE_TIME), locale);
const $eccb9ac84cb9c146$export$4fb1e26192f7e97e = (date, locale)=>(0, $4pirX.format)(date, (0, $4jeQc.ISO_LOCAL_DATE_WITH_SLASHES), {
        locale: locale
    });
const $eccb9ac84cb9c146$export$aa4631c15cf4aa6c = (date, locale)=>$eccb9ac84cb9c146$export$fb3485f471c77284(date, (0, $4jeQc.MONTH_ONLY_FORMAT), locale);
const $eccb9ac84cb9c146$export$576edf138d340b5d = (date, locale)=>(0, $4pirX.format)(date, (0, $4jeQc.ISO_LOCAL_DATE), {
        locale: locale
    });
const $eccb9ac84cb9c146$export$558b4e1f078554d3 = (date, locale)=>(0, $4pirX.format)((0, $3Vbz9.utcToZonedTime)(date, 'UTC', {
        locale: locale
    }), (0, $4jeQc.ISO_LOCAL_DATE_TIME), {
        locale: locale
    });
const $eccb9ac84cb9c146$export$1563a4bbc9fdec3a = (intl, start, end, anchorDate = (0, $cn4qU.tzDate)(), locale)=>{
    if ((0, $4pirX.isSameWeek)(anchorDate, start, {
        locale: locale
    })) return intl.formatMessage({
        id: "townsquare.date-utils.week-range.this-week",
        defaultMessage: "This week"
    });
    else if ($eccb9ac84cb9c146$export$e83bab6391267bac(anchorDate, end, locale)) return intl.formatMessage({
        id: "townsquare.date-utils.week-range.last-week",
        defaultMessage: "Last week"
    });
    else return $eccb9ac84cb9c146$export$2e9241a0bdf6c8b8(start, end, locale);
};
const $eccb9ac84cb9c146$export$9882f45862b3ea7b = (start, end, anchorDate = (0, $cn4qU.tzDate)(), locale)=>{
    const intl = (0, $aXWIB.useIntl)();
    return $eccb9ac84cb9c146$export$1563a4bbc9fdec3a(intl, start, end, anchorDate, locale);
};
function $eccb9ac84cb9c146$export$e83bab6391267bac(newer, older, locale) {
    return (0, $4pirX.differenceInCalendarWeeks)(newer, older, {
        locale: locale
    }) === 1;
}
module.exports["formatNiceDate"] = $eccb9ac84cb9c146$export$9b0e8a03930c4b1e;
module.exports["formatNiceMonthDate"] = $eccb9ac84cb9c146$export$cec1db3fd4087308;
module.exports["formatWithLocale"] = $eccb9ac84cb9c146$export$fb3485f471c77284;
module.exports["formatTooltipNiceMonthDate"] = $eccb9ac84cb9c146$export$446ec9bc291d6ba4;
module.exports["formatNiceIntervalRangeDate"] = $eccb9ac84cb9c146$export$a759ab4dd7c186ad;
module.exports["formatNiceQuarterDate"] = $eccb9ac84cb9c146$export$65cbe7f37a8de928;
module.exports["formatTooltipNiceQuarterDate"] = $eccb9ac84cb9c146$export$aeec403faa363c87;
module.exports["formatNiceDateTooltip"] = $eccb9ac84cb9c146$export$47fbc3e2a5240e18;
module.exports["formatNiceDateTime"] = $eccb9ac84cb9c146$export$dcb72c0d0fb82631;
module.exports["formatMonthOnlyDate"] = $eccb9ac84cb9c146$export$aa4631c15cf4aa6c;
module.exports["formatIsoLocalDate"] = $eccb9ac84cb9c146$export$576edf138d340b5d;
module.exports["formatWeekRange"] = $eccb9ac84cb9c146$export$1563a4bbc9fdec3a;

});

parcelRegister("5eayg", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ce671e8d760353b$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $3ce671e8d760353b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3 + 3;
    date.setMonth(month, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("9tcaE", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e50435688736d92$export$2e2bcd8739ae039);

var $fakaf = parcelRequire("fakaf");


var $b5utg = parcelRequire("b5utg");

function $6e50435688736d92$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    return (0, $fakaf.default)(dirtyDate, Date.now());
}

});

parcelRegister("cPLkE", function(module, exports) {
$parcel$export(module.exports, "default", () => $957ef6a195e9f3e4$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $957ef6a195e9f3e4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3;
    date.setMonth(month, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("cn4qU", function(module, exports) {

var $3Vbz9 = parcelRequire("3Vbz9");


var $922yL = parcelRequire("922yL");


var $4TIFs = parcelRequire("4TIFs");


var $e1kiJ = parcelRequire("e1kiJ");


var $2Hy4R = parcelRequire("2Hy4R");


var $d6omw = parcelRequire("d6omw");


var $e0SBo = parcelRequire("e0SBo");


var $dlSEv = parcelRequire("dlSEv");


var $5ISS4 = parcelRequire("5ISS4");


var $bzSU8 = parcelRequire("bzSU8");


var $ksiqf = parcelRequire("ksiqf");


var $2aVgd = parcelRequire("2aVgd");


var $6gF1I = parcelRequire("6gF1I");


var $4pirX = parcelRequire("4pirX");


var $6ra35 = parcelRequire("6ra35");


var $5fnuR = parcelRequire("5fnuR");

const $3b3f57678ecf9555$export$f1dfefafe68679f = ()=>(0, $6gF1I.default)($3b3f57678ecf9555$export$b3be5876ddaf77c4(), 1);
const $3b3f57678ecf9555$export$21bad1dbf7fdd0f1 = (date)=>(0, $4pirX.isSameWeek)(date, $3b3f57678ecf9555$export$b3be5876ddaf77c4());
const $3b3f57678ecf9555$export$815a780eb1151f78 = (date)=>(0, $4pirX.isSameWeek)(date, $3b3f57678ecf9555$export$53deaf8cee4d3edf());
const $3b3f57678ecf9555$export$8be2b5b9a7e1742 = (date)=>(0, $4pirX.isSameWeek)(date, (0, $e1kiJ.default)($3b3f57678ecf9555$export$b3be5876ddaf77c4(), -1));
const $3b3f57678ecf9555$export$c1ffdc8d1b5a290b = (date)=>(0, $4pirX.isSameWeek)(date, (0, $e1kiJ.default)($3b3f57678ecf9555$export$53deaf8cee4d3edf(), -1));
const $3b3f57678ecf9555$export$f22a8550507539dc = (date)=>(0, $bzSU8.default)(date, (0, $4TIFs.default)($3b3f57678ecf9555$export$b3be5876ddaf77c4(), -1));
const $3b3f57678ecf9555$export$c683c625e600737d = (date, amount)=>(0, $922yL.default)(date, amount);
const $3b3f57678ecf9555$export$f7395c2abb5c1a2d = (date, amount)=>(0, $4TIFs.default)(date, amount);
const $3b3f57678ecf9555$export$601d6cf336d1ee54 = (date, amount)=>(0, $ksiqf.default)(date, amount);
const $3b3f57678ecf9555$export$d91d3014a3a25a08 = (date, amount)=>(0, $2aVgd.default)(date, amount);
const $3b3f57678ecf9555$export$a1dd290013a5c209 = (date, startDate)=>(0, $dlSEv.default)(date, startDate);
const $3b3f57678ecf9555$export$7467d14fa50f8750 = (date, endDate)=>(0, $e0SBo.default)(date, endDate);
const $3b3f57678ecf9555$export$b3be5876ddaf77c4 = (dateString)=>$3b3f57678ecf9555$export$539661515529bef(dateString);
const $3b3f57678ecf9555$export$539661515529bef = (dateString)=>{
    return dateString ? (0, $6ra35.utcToWorkspaceTimezone)(dateString) : (0, $3Vbz9.utcToZonedTime)(Date.now(), (0, $5fnuR.timezoneHolder).getWorkspaceTimezone());
};
/**
 * Used for offsetting UTC dates to the workspace timezone.
 * For example. Lets say we wanted start of day in America/Los Angeles [-08:00]
 * We can pass in 00:00PM UTC here - and this function will offset to 08:00PM UTC
 */ const $3b3f57678ecf9555$var$offsetUtcDateToWorkspaceDate = (date)=>{
    const timezoneOffset = (0, $3Vbz9.getTimezoneOffset)((0, $5fnuR.timezoneHolder).getWorkspaceTimezone());
    return new Date(date.valueOf() - timezoneOffset);
};
/**
 * Used for offsetting workspace timezoned dates back to UTC.
 */ const $3b3f57678ecf9555$var$offsetWorkspaceDateToUtcDate = (date)=>{
    const timezoneOffset = (0, $3Vbz9.getTimezoneOffset)((0, $5fnuR.timezoneHolder).getWorkspaceTimezone());
    return new Date(date.valueOf() + timezoneOffset);
};
const $3b3f57678ecf9555$export$53deaf8cee4d3edf = (dateString)=>dateString ? (0, $6ra35.utcToUserTimezone)(dateString) : (0, $3Vbz9.utcToZonedTime)(Date.now(), (0, $5fnuR.timezoneHolder).getUserTimezone());
/**
 * Used for offsetting dates created with date-fns (start of day etc) that actually need to be UTC time.
 * For example. a startOfDay in australia would generate 00:00PM AEST, but that's 1:00PM UTC the previous day
 * This function will offset by the timezone difference, +11:00 in this case. Bringing us back to 00:00PM UTC.
 */ const $3b3f57678ecf9555$var$offsetUserDateToUtcDate = (date)=>{
    const timezoneOffset = (0, $3Vbz9.getTimezoneOffset)((0, $5fnuR.timezoneHolder).getUserTimezone());
    return new Date(date.valueOf() + timezoneOffset);
};
/**
 * Used for offsetting utc dates to the user's timezone.
 */ const $3b3f57678ecf9555$var$offsetUtcDateToUserDate = (date)=>{
    const timezoneOffset = (0, $3Vbz9.getTimezoneOffset)((0, $5fnuR.timezoneHolder).getUserTimezone());
    return new Date(date.valueOf() - timezoneOffset);
};
const $3b3f57678ecf9555$export$56b8b35841afd41e = (date)=>$3b3f57678ecf9555$var$offsetUtcDateToWorkspaceDate($3b3f57678ecf9555$var$offsetUserDateToUtcDate(date));
const $3b3f57678ecf9555$export$c9e317ac9a609d9c = (date)=>$3b3f57678ecf9555$var$offsetUtcDateToUserDate($3b3f57678ecf9555$var$offsetWorkspaceDateToUtcDate(date));
const $3b3f57678ecf9555$export$200ab5b8c99897d7 = (dateString)=>dateString ? (0, $5ISS4.default)(new Date(`${dateString.split('T')[0]}T23:59:59`)) : false;
const $3b3f57678ecf9555$export$d7fd361eccb0059b = (newDate, oldDate)=>(0, $2Hy4R.default)(new Date(newDate), new Date(oldDate));
const $3b3f57678ecf9555$export$f76f483821e339a0 = (newTime, oldTime)=>(0, $d6omw.default)(Number(newTime), Number(oldTime)) > 5;
module.exports["tzDate"] = $3b3f57678ecf9555$export$b3be5876ddaf77c4;
module.exports["tzUserTimezoneDate"] = $3b3f57678ecf9555$export$53deaf8cee4d3edf;
module.exports["plusMonths"] = $3b3f57678ecf9555$export$f7395c2abb5c1a2d;
module.exports["minusMonths"] = $3b3f57678ecf9555$export$d91d3014a3a25a08;
module.exports["tzWorkspaceTimezoneDate"] = $3b3f57678ecf9555$export$539661515529bef;
module.exports["isDateInThePast"] = $3b3f57678ecf9555$export$200ab5b8c99897d7;

});

parcelRegister("5ISS4", function(module, exports) {
$parcel$export(module.exports, "default", () => $42aba00b8a00cdd3$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $42aba00b8a00cdd3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    return (0, $egXhZ.default)(dirtyDate).getTime() < Date.now();
}

});

parcelRegister("6ra35", function(module, exports) {

var $3Vbz9 = parcelRequire("3Vbz9");


var $c3Z6w = parcelRequire("c3Z6w");


var $5UrJe = parcelRequire("5UrJe");


var $5fnuR = parcelRequire("5fnuR");

const $291cdae29cca0e94$export$9395a61a87d21679 = (dateTime, timezone)=>{
    const date = typeof dateTime === 'object' ? Date.parse(String(dateTime)) : Date.parse(dateTime && String(dateTime + '').endsWith('Z') ? dateTime : dateTime + 'Z');
    if (isNaN(date)) return (0, $5UrJe.parseIsoLocalDateTime)(dateTime, new Date(NaN));
    return (0, $3Vbz9.utcToZonedTime)(date, timezone);
};
const $291cdae29cca0e94$export$5f6fbd4959e944da = (dt)=>$291cdae29cca0e94$export$9395a61a87d21679(dt, (0, $5fnuR.timezoneHolder).getUserTimezone());
const $291cdae29cca0e94$export$389c2a1270efa748 = (dt)=>$291cdae29cca0e94$export$9395a61a87d21679(dt, (0, $5fnuR.timezoneHolder).getWorkspaceTimezone());
const $291cdae29cca0e94$export$caa193559b3a89ec = (dateString, locale)=>dateString ? (0, $c3Z6w.default)($291cdae29cca0e94$export$5f6fbd4959e944da(dateString), (0, $3Vbz9.utcToZonedTime)(Date.now(), (0, $5fnuR.timezoneHolder).getUserTimezone(), {
        locale: locale
    }), {
        addSuffix: true,
        locale: locale
    }) : '-';
const $291cdae29cca0e94$export$7ce4a53d328e1580 = (dateString, locale)=>{
    if (!dateString) return '-';
    const startDate = new Date(dateString);
    startDate.setHours(0, 0, 0, 0);
    const userTimezone = (0, $5fnuR.timezoneHolder).getUserTimezone();
    const baseDate = (0, $3Vbz9.utcToZonedTime)(Date.now(), userTimezone, {
        locale: locale
    });
    return (0, $c3Z6w.default)(startDate, baseDate, {
        addSuffix: true,
        locale: locale
    });
};
module.exports["utcToUserTimezone"] = $291cdae29cca0e94$export$5f6fbd4959e944da;
module.exports["utcToWorkspaceTimezone"] = $291cdae29cca0e94$export$389c2a1270efa748;
module.exports["formatUserRelativeDistance"] = $291cdae29cca0e94$export$caa193559b3a89ec;

});

parcelRegister("5fnuR", function(module, exports) {
const $ccc72d3760e5382c$export$14ec4245743e2694 = ()=>Intl.DateTimeFormat().resolvedOptions().timeZone;
/**
 * A way to hold timezone information so it's accessible outside of a react component
 */ class $ccc72d3760e5382c$var$TimezoneHolder {
    getWorkspaceTimezone() {
        // Resolve to user timezone if global/workspace timezone is undefined
        return this.workspaceTimezone || $ccc72d3760e5382c$export$14ec4245743e2694();
    }
    getUserTimezone() {
        return this.userAccountTimezone || $ccc72d3760e5382c$export$14ec4245743e2694();
    }
    setWorkspaceTimezone(workspaceTimezone) {
        // this.timezone = 'America/New_York';
        // this.timezone = 'Australia/Sydney';
        this.workspaceTimezone = workspaceTimezone;
    }
    setUserTimezone(userAccountTimezone) {
        this.userAccountTimezone = userAccountTimezone;
    }
    constructor(workspaceTimezone, userAccountTimezone){
        this.workspaceTimezone = void 0;
        this.userAccountTimezone = void 0;
        this.workspaceTimezone = workspaceTimezone;
        this.userAccountTimezone = userAccountTimezone;
    }
}
const $ccc72d3760e5382c$export$438f03caaf265d92 = new $ccc72d3760e5382c$var$TimezoneHolder();
module.exports["timezoneHolder"] = $ccc72d3760e5382c$export$438f03caaf265d92;

});

parcelRegister("86DeN", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");


var $bCd2g = parcelRequire("bCd2g");

var $b03a509836b96487$export$d19e7d63e5f456d1 = /*#__PURE__*/ function(ChangeSource) {
    ChangeSource["DATE_SELECT"] = "DATE_SELECT";
    ChangeSource["SCALE_SELECT"] = "SCALE_SELECT";
    return ChangeSource;
}({});



var $2ROAs = parcelRequire("2ROAs");








var $jBv2F = parcelRequire("jBv2F");


var $5eayg = parcelRequire("5eayg");


var $da71s = parcelRequire("da71s");


var $8uChS = parcelRequire("8uChS");


var $cPLkE = parcelRequire("cPLkE");











var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $2uNcU = parcelRequire("2uNcU");












var $cFEpk = parcelRequire("cFEpk");


var $jqWS9 = parcelRequire("jqWS9");





var $a4TK8 = parcelRequire("a4TK8");


var $91bEl = parcelRequire("91bEl");







const $433bb48873b31cb1$var$getDateObj = (date)=>({
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear()
    });
const $433bb48873b31cb1$var$getValidDate = (iso)=>{
    if (!iso) return {};
    const date = (0, $da71s.default)(iso);
    return (0, $cFEpk.default)(date) ? $433bb48873b31cb1$var$getDateObj(date) : {};
};
const $433bb48873b31cb1$export$a7de57e5b672ccdb = (num)=>num <= 99 ? `0${num}`.slice(-2) : `${num}`;
const $433bb48873b31cb1$export$97e6db89a86ff7ab = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const currentDate = props.date;
    const previousDate = props.previousDate;
    const { minDate: minDate, maxDate: maxDate } = props;
    const [viewDate, setViewDate] = (0, $42omo.useState)(currentDate);
    const locale = (0, $bCd2g.useDateLocale)();
    const onSelect = (0, $42omo.useCallback)((iso)=>{
        setViewDate(iso);
        const newDateObj = {
            start: iso,
            end: iso
        };
        props.onSelect(newDateObj);
    }, [
        props
    ]);
    const onChange = (0, $42omo.useCallback)((iso)=>{
        if (!iso) return;
        const [year, month, date] = iso.split('-');
        let newIso = iso;
        const parsedDate = parseInt(date, 10);
        const parsedMonth = parseInt(month, 10);
        const parsedYear = parseInt(year, 10);
        const lastDayInMonth = (0, $jqWS9.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
        if (lastDayInMonth < parsedDate) newIso = `${year}-${$433bb48873b31cb1$export$a7de57e5b672ccdb(parsedMonth)}-${$433bb48873b31cb1$export$a7de57e5b672ccdb(lastDayInMonth)}`;
        else newIso = `${year}-${$433bb48873b31cb1$export$a7de57e5b672ccdb(parsedMonth)}-${$433bb48873b31cb1$export$a7de57e5b672ccdb(parsedDate)}`;
        setViewDate(newIso);
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $91bEl.default), {
        ...$433bb48873b31cb1$var$getValidDate(viewDate),
        minDate: minDate ? (0, $2uNcU.formatIsoLocalDate)(minDate, locale) : undefined,
        maxDate: maxDate ? (0, $2uNcU.formatIsoLocalDate)(maxDate, locale) : undefined,
        selected: [
            currentDate || ''
        ],
        previouslySelected: previousDate ? [
            previousDate
        ] : [],
        onChange: (e)=>onChange(e.iso),
        onSelect: (e)=>onSelect(e.iso)
    });
}, (prevProps, nextProps)=>(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(prevProps.date, nextProps.date));


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gMc0m = parcelRequire("gMc0m");


var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $670f1b8d2329d797$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}



var $eLAgW = parcelRequire("eLAgW");


var $8lMgE = parcelRequire("8lMgE");







var $1qfLF = parcelRequire("1qfLF");


var $laHi9 = parcelRequire("laHi9");


var $6R5uz = parcelRequire("6R5uz");




var $1s5hv = parcelRequire("1s5hv");



var $iXCQx = parcelRequire("iXCQx");





var $5UrJe = parcelRequire("5UrJe");







const $f8e55884fab2b31a$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    quarterPickerButtonMessage: {
        id: "date-range-picker.date-range-picker-content.quarter-picker-button-message",
        defaultMessage: "Quarter"
    },
    monthPickerButtonMessage: {
        id: "date-range-picker.date-range-picker-content.month-picker-button-message",
        defaultMessage: "Month"
    },
    dayPickerButtonMessage: {
        id: "date-range-picker.date-range-picker-content.day-picker-button-message",
        defaultMessage: "Day"
    },
    intervalPickerButtonMessage: {
        id: "date-range-picker.date-range-picker-content.interval-picker-button-message",
        defaultMessage: "Interval"
    },
    intervalOptionAriaLabel: {
        id: "date-range-picker.date-range-picker-content.interval-option-aria-label",
        defaultMessage: "{name}, {dateRange}"
    }
});


const $3737d735d97a8978$var$styles = {
    yearPickerPadding: "_19bvu2gc _u5f3u2gc",
    intervalPickerWrapper: "_1rjcpxbi _18zrpxbi"
};
const $3737d735d97a8978$var$intervalPickerContainerStyles = null; /**
                                             * Resolves an IntervalOption's dates into the given display year,
                                             * returning the actual start and end Date objects for that year.
                                             */ 
function $3737d735d97a8978$var$resolveIntervalDates(interval, year) {
    return {
        start: new Date(year, interval.startDate.getMonth(), interval.startDate.getDate()),
        end: new Date(year, interval.endDate.getMonth(), interval.endDate.getDate())
    };
} /**
   * Checks whether an interval (resolved to the display year) falls within a date range,
   * i.e. the interval's start is >= rangeStart and the interval's end is <= rangeEnd.
   */ 
function $3737d735d97a8978$var$isIntervalInRange(interval, displayYear, rangeStart, rangeEnd) {
    const { start: start, end: end } = $3737d735d97a8978$var$resolveIntervalDates(interval, displayYear);
    return start >= rangeStart && end <= rangeEnd;
}
const $3737d735d97a8978$export$e2c8a770d777dfd1 = (props)=>{
    const { date: date, onSelect: onSelect, minDate: minDate, maxDate: maxDate, intervals: intervals, isRangeSelect: isRangeSelect = false } = props;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [displayYear, setDisplayYear] = (0, $42omo.useState)(()=>date?.start ? (0, $8lMgE.default)((0, $5UrJe.parseValueToLocalDate)(date.start)) : (0, $8lMgE.default)(intervals[0]?.startDate ?? new Date()) ?? (0, $8lMgE.default)(new Date()));
    (0, $42omo.useEffect)(()=>{
        if (date?.start) setDisplayYear((0, $8lMgE.default)((0, $5UrJe.parseValueToLocalDate)(date.start)));
    }, [
        date?.start
    ]);
    const valueStart = date?.start ? (0, $5UrJe.parseValueToLocalDate)(date.start) : null;
    const valueEnd = date?.end ? (0, $5UrJe.parseValueToLocalDate)(date.end) : null;
    const locale = (0, $bCd2g.useDateLocale)(); // Range selection state: stores the actual resolved start date and the
    // IntervalOption of the pending start. null means no pending start has been picked yet.
    const [pendingRangeStart, setPendingRangeStart] = (0, $42omo.useState)(null);
    const onDateChange = (0, $42omo.useCallback)((interval)=>{
        onSelect((0, $bCd2g.intervalToDatePickerValue)(interval, displayYear, locale), interval);
    }, [
        displayYear,
        locale,
        onSelect
    ]);
    const onRangeDateChange = (0, $42omo.useCallback)((interval)=>{
        const clicked = $3737d735d97a8978$var$resolveIntervalDates(interval, displayYear);
        if (pendingRangeStart === null) // First click: store the actual start date and interval.
        setPendingRangeStart({
            date: clicked.start,
            interval: interval
        });
        else {
            // Second click: determine end.
            if (clicked.start < pendingRangeStart.date) {
                // Validation: if the clicked interval starts before the pending start,
                // treat it as a new start.
                setPendingRangeStart({
                    date: clicked.start,
                    interval: interval
                });
                return;
            }
            const rangeValue = {
                start: (0, $2uNcU.formatIsoLocalDate)(pendingRangeStart.date, locale),
                end: (0, $2uNcU.formatIsoLocalDate)(clicked.end, locale)
            }; // Build a combined display name for the range.
            // If start and end are the same interval, use just that name;
            // otherwise join them with an en-dash (e.g. "Period 1 – Period 3").
            const startInterval = pendingRangeStart.interval;
            const displayInterval = startInterval.name === interval.name ? interval : {
                ...startInterval,
                name: `${startInterval.name} \u{2013} ${interval.name}`,
                endDate: interval.endDate
            };
            setPendingRangeStart(null);
            onSelect(rangeValue, displayInterval);
        }
    }, [
        pendingRangeStart,
        displayYear,
        locale,
        onSelect
    ]);
    const isIntervalDisabled = (0, $42omo.useCallback)((_isSelected, interval)=>{
        if (minDate && interval.endDate < minDate) return true;
        if (maxDate && interval.startDate > maxDate) return true;
        return false;
    }, [
        minDate,
        maxDate
    ]); /**
                           * Determines whether an interval should be visually selected.
                           * In range-select mode, this includes the pending start interval
                           * and all intervals within a committed range.
                           */ 
    const isIntervalSelected = (0, $42omo.useCallback)((item)=>{
        if (!isRangeSelect) // Single-select mode: match exact interval
        return valueStart != null && valueEnd != null && (0, $8lMgE.default)(valueStart) === displayYear && (0, $eLAgW.default)(valueStart) === (0, $eLAgW.default)(item.startDate) && (0, $670f1b8d2329d797$export$2e2bcd8739ae039)(valueStart) === (0, $670f1b8d2329d797$export$2e2bcd8739ae039)(item.startDate) && (0, $eLAgW.default)(valueEnd) === (0, $eLAgW.default)(item.endDate) && (0, $670f1b8d2329d797$export$2e2bcd8739ae039)(valueEnd) === (0, $670f1b8d2329d797$export$2e2bcd8739ae039)(item.endDate);
         // Range-select mode
        if (pendingRangeStart !== null) {
            // Highlight the pending start interval
            const { start: start } = $3737d735d97a8978$var$resolveIntervalDates(item, displayYear);
            return start.getTime() === pendingRangeStart.date.getTime();
        } // Show the committed range
        if (valueStart != null && valueEnd != null) return $3737d735d97a8978$var$isIntervalInRange(item, displayYear, valueStart, valueEnd);
        return false;
    }, [
        isRangeSelect,
        valueStart,
        valueEnd,
        displayYear,
        pendingRangeStart
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $3737d735d97a8978$var$styles.intervalPickerWrapper,
        testId: "interval-picker-wrapper",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                justifyContent: "space-between",
                alignItems: "center",
                xcss: $3737d735d97a8978$var$styles.yearPickerPadding,
                testId: "year-picker-container",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        appearance: "subtle",
                        spacing: "compact",
                        onClick: ()=>setDisplayYear(displayYear - 1),
                        label: "Button to see previous year",
                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
                                ...iconProps,
                                size: "small"
                            })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("b", {
                        children: displayYear
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        appearance: "subtle",
                        spacing: "compact",
                        onClick: ()=>setDisplayYear(displayYear + 1),
                        label: "Button to see next year",
                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                                ...iconProps,
                                size: "small"
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                role: "radiogroup",
                className: (0, $gMc0m.default)([
                    "_zulpu2gc _19pkpxbi _1e0c1txw _1n261g80 _1bah1b1v _ae4v1y6m _4t3ieoa3 _hxt6idpf _cs56idpf _1yp3ufqz _t74o1nzx _a7a01txw _18iz1h6o _t3701h6o _r6ob1nzx _1kne1nzx"
                ]),
                children: intervals.map((item)=>{
                    const startInDisplayYear = new Date(displayYear, item.startDate.getMonth(), item.startDate.getDate());
                    const endInDisplayYear = new Date(displayYear, item.endDate.getMonth(), item.endDate.getDate());
                    const dateRangeLabel = `${(0, $2uNcU.formatWithLocale)(startInDisplayYear, 'MMM d', locale)} - ${(0, $2uNcU.formatWithLocale)(endInDisplayYear, 'MMM d', locale)}`;
                    const isSelected = isIntervalSelected(item);
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        appearance: "subtle",
                        onClick: ()=>isRangeSelect ? onRangeDateChange(item) : onDateChange(item),
                        isSelected: isSelected,
                        "aria-checked": isSelected,
                        "aria-label": formatMessage((0, $f8e55884fab2b31a$export$defe85febe8b728c).intervalOptionAriaLabel, {
                            name: item.name,
                            dateRange: dateRangeLabel
                        }),
                        role: "radio",
                        isDisabled: isIntervalDisabled(isSelected, item),
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                            as: "span",
                            alignInline: "center",
                            space: "space.025",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    weight: "medium",
                                    color: "inherit",
                                    align: "center",
                                    children: item.name
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    size: "small",
                                    color: "inherit",
                                    align: "center",
                                    children: dateRangeLabel
                                })
                            ]
                        })
                    }, `${item.startDate.getTime()}-${item.endDate.getTime()}`);
                })
            })
        ]
    });
};



/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $e0SBo = parcelRequire("e0SBo");


var $dlSEv = parcelRequire("dlSEv");


























const $5df827cd4e9fb188$var$yearPickerContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    marginBottom: 'space.200'
});
const $5df827cd4e9fb188$var$monthPickerContainerStyles = null;
const $5df827cd4e9fb188$var$monthPickerWrapperStyles = (0, $ecnYn.xcss)({
    padding: 'space.200'
});
const $5df827cd4e9fb188$var$getMonthNames = (locale)=>{
    const today = new Date();
    const months = [];
    for(let i = 0; i < 12; i++)months.push({
        month: i,
        name: (0, $2uNcU.formatWithLocale)(new Date(today.getFullYear(), i), 'MMM', locale)
    });
    return months;
};
const $5df827cd4e9fb188$export$6e979f880d369f74 = (props)=>{
    const [date, setDate] = (0, $42omo.useState)((0, $bCd2g.getInitialMonthPickerDate)(props));
    const previousDate = (0, $bCd2g.getMonthPickerDate)(props.previousDate);
    const locale = (0, $bCd2g.useDateLocale)();
    const { selectedDate: selectedDate, dateType: dateType, onSelect: onSelect, withTimeScale: withTimeScale, minDate: minDate, maxDate: maxDate } = props;
    const { month: month, year: year, initialYear: initialYear } = date;
    const MONTHS_DATA = $5df827cd4e9fb188$var$getMonthNames(locale);
    const onDateChange = (0, $42omo.useCallback)((newDate)=>{
        setDate(newDate);
        const newDateObject = new Date(newDate.year, newDate.month);
        const newDateInterval = {
            start: (0, $2uNcU.formatIsoLocalDate)((0, $8uChS.default)(newDateObject), locale),
            end: (0, $2uNcU.formatIsoLocalDate)((0, $jBv2F.default)(newDateObject), locale)
        };
        onSelect(newDateInterval);
    }, [
        onSelect,
        locale
    ]);
    const isMonthDisabled = (0, $42omo.useCallback)((isSelected, monthItem)=>{
        const currentMonth = new Date(year, monthItem);
        const monthStart = (0, $8uChS.default)(currentMonth);
        const monthEnd = (0, $jBv2F.default)(currentMonth);
        if (minDate && monthEnd < minDate) return true;
        if (maxDate && monthStart > maxDate) return true;
        if (!selectedDate) return false;
        return !isSelected && (dateType === 'start' ? (0, $dlSEv.default)(selectedDate, currentMonth) : (0, $e0SBo.default)(selectedDate, currentMonth));
    }, [
        dateType,
        selectedDate,
        year,
        minDate,
        maxDate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $5df827cd4e9fb188$var$monthPickerWrapperStyles,
        children: [
            withTimeScale && /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                xcss: $5df827cd4e9fb188$var$yearPickerContainerStyles,
                testId: "year-picker-container",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        appearance: "subtle",
                        spacing: "compact",
                        onClick: ()=>setDate({
                                initialYear: initialYear,
                                month: month,
                                year: year - 1
                            }),
                        label: "Button to see previous year",
                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
                                ...iconProps,
                                size: "small"
                            })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("b", {
                        children: year
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        appearance: "subtle",
                        spacing: "compact",
                        onClick: ()=>setDate({
                                initialYear: initialYear,
                                month: month,
                                year: year + 1
                            }),
                        label: "Button to see next year",
                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                                ...iconProps,
                                size: "small"
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                "data-testid": "month-picker-container",
                role: "radiogroup",
                className: (0, $gMc0m.default)([
                    "_1e0c1txw _1n261g80 _1bah1b1v _hxt6idpf _cs56idpf _1yp31hc1 _t74oymf6 _2gv61b66 _925w1h6o _ye0m15s3 _lb4mazsu"
                ]),
                children: MONTHS_DATA.map((item)=>{
                    const isSelected = date.initialYear === year && month === item.month;
                    const isPreviouslySelected = previousDate ? previousDate.year === year && previousDate.month === item.month : false;
                    if (isPreviouslySelected) return /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        id: "previously-selected-month-option",
                        appearance: "subtle",
                        testId: "previously-selected-month-option",
                        "aria-checked": false,
                        "aria-label": item.name,
                        role: "radio",
                        children: item.name
                    }, item.month);
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        appearance: "subtle",
                        onClick: ()=>onDateChange({
                                initialYear: year,
                                year: year,
                                month: item.month
                            }),
                        isSelected: isSelected,
                        isDisabled: isMonthDisabled(isSelected, item.month),
                        testId: isSelected ? 'selected-month-option' : 'month-option',
                        "aria-checked": isSelected,
                        "aria-label": item.name,
                        role: "radio",
                        children: item.name
                    }, item.month);
                })
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


















var $9gbhg = parcelRequire("9gbhg");


























const $1eae92c5ca3b6a84$var$yearPickerContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});
const $1eae92c5ca3b6a84$var$quarterPickerContainerStyles = null;
const $1eae92c5ca3b6a84$var$quarterPickerWrapperStyles = (0, $ecnYn.xcss)({
    padding: 'space.200'
});
const $1eae92c5ca3b6a84$var$getQuarterData = (locale)=>{
    const today = new Date();
    const quarters = [];
    for(let i = 0; i < 12; i += 3)quarters.push({
        months: [
            i,
            i + 1,
            i + 2
        ],
        name: `${(0, $2uNcU.formatWithLocale)(new Date(today.getFullYear(), i), 'MMM', locale)}-${(0, $2uNcU.formatWithLocale)(new Date(today.getFullYear(), i + 2), 'MMM', locale)}`
    });
    return quarters;
};
const $1eae92c5ca3b6a84$export$1f3b9af4e880de43 = (props)=>{
    const [date, setDate] = (0, $42omo.useState)((0, $bCd2g.getInitialMonthPickerDate)(props));
    const previousDate = (0, $bCd2g.getMonthPickerDate)(props.previousDate);
    const { selectedDate: selectedDate, dateType: dateType, onSelect: onSelect, minDate: minDate, maxDate: maxDate } = props;
    const { month: month, year: year, initialYear: initialYear } = date;
    const locale = (0, $9gbhg.default);
    const onDateChange = (0, $42omo.useCallback)((newDate)=>{
        setDate(newDate);
        const newDateObject = new Date(newDate.year, newDate.month);
        const newDateInterval = {
            start: (0, $2uNcU.formatIsoLocalDate)((0, $cPLkE.default)(newDateObject), locale),
            end: (0, $2uNcU.formatIsoLocalDate)((0, $5eayg.default)(newDateObject), locale)
        };
        onSelect(newDateInterval);
    }, [
        locale,
        onSelect
    ]);
    const QUARTER_DATA = $1eae92c5ca3b6a84$var$getQuarterData(locale);
    const isQuarterDisabled = (0, $42omo.useCallback)((isSelected, endQuarter)=>{
        const currentQuarter = new Date(year, endQuarter);
        const quarterStart = (0, $cPLkE.default)(currentQuarter);
        const quarterEnd = (0, $5eayg.default)(currentQuarter);
        if (minDate || maxDate) {
            if (minDate && quarterEnd < minDate) return true;
            if (maxDate && quarterStart > maxDate) return true;
        }
        if (!selectedDate) return false;
        const currentDate = new Date(year, endQuarter);
        return !isSelected && (dateType === 'start' ? (0, $dlSEv.default)(selectedDate, currentDate) : (0, $e0SBo.default)(selectedDate, currentDate));
    }, [
        dateType,
        selectedDate,
        year,
        minDate,
        maxDate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $1eae92c5ca3b6a84$var$quarterPickerWrapperStyles,
        testId: "quarter-picker-wrapper",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                xcss: $1eae92c5ca3b6a84$var$yearPickerContainerStyles,
                testId: "year-picker-container",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        appearance: "subtle",
                        spacing: "compact",
                        onClick: ()=>setDate({
                                initialYear: initialYear,
                                month: month,
                                year: year - 1
                            }),
                        label: "Button to see previous year",
                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
                                ...iconProps,
                                size: "small"
                            })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("b", {
                        children: year
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        appearance: "subtle",
                        spacing: "compact",
                        onClick: ()=>setDate({
                                initialYear: initialYear,
                                month: month,
                                year: year + 1
                            }),
                        label: "Button to see next year",
                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                                ...iconProps,
                                size: "small"
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                "data-testid": "quarter-picker-container",
                role: "radiogroup",
                className: (0, $gMc0m.default)([
                    "_19pkpxbi _1e0c1txw _1n261g80 _1bah1b1v _4t3ieoa3 _hxt6idpf _cs56idpf _1yp31ssb _t74o1nzx _r6ob1nzx _1kne1nzx _925w1h6o _fgt515s3 _17hvazsu"
                ]),
                children: QUARTER_DATA.map((item)=>{
                    const startQuarter = item.months[0];
                    const endQuarter = item.months[2];
                    const isSelected = date.initialYear === year && item.months.includes(month);
                    const isPreviouslySelected = previousDate ? previousDate.year === year && item.months.includes(previousDate.month) : false;
                    if (isPreviouslySelected) return /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        id: "previously-selected-quarter-option",
                        appearance: "subtle",
                        testId: "previously-selected-quarter-option",
                        "aria-checked": false,
                        "aria-label": item.name,
                        role: "radio",
                        children: item.name
                    }, startQuarter);
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        appearance: "subtle",
                        onClick: ()=>onDateChange({
                                initialYear: year,
                                year: year,
                                month: endQuarter
                            }),
                        isSelected: isSelected,
                        "aria-checked": isSelected,
                        "aria-label": item.name,
                        role: "radio",
                        isDisabled: isQuarterDisabled(isSelected, endQuarter),
                        children: item.name
                    }, startQuarter);
                })
            })
        ]
    });
};


const $1d78840c165b0399$var$buttonGroupStyles = (0, $ecnYn.xcss)({
    padding: 'space.250',
    display: 'grid',
    gap: 'space.050',
    gridTemplateColumns: 'repeat(3, 1fr)',
    justifyContent: 'center'
});
const $1d78840c165b0399$var$datePickerContentWrapperStyles = (0, $ecnYn.xcss)({
    width: '322px'
});
const $1d78840c165b0399$var$DEFAULT_GRANULARITIES = [
    (0, $bCd2g.DateRangeScale).DAY,
    (0, $bCd2g.DateRangeScale).MONTH,
    (0, $bCd2g.DateRangeScale).QUARTER
];
const $1d78840c165b0399$var$getDateValueForScale = (endDateIso, newScale, locale)=>{
    const endDate = (0, $da71s.default)(endDateIso);
    switch(newScale){
        case (0, $bCd2g.DateRangeScale).DAY:
            return {
                start: endDateIso,
                end: endDateIso
            };
        case (0, $bCd2g.DateRangeScale).MONTH:
            {
                const start = (0, $2uNcU.formatIsoLocalDate)((0, $8uChS.default)(endDate), locale);
                const end = (0, $2uNcU.formatIsoLocalDate)((0, $jBv2F.default)(endDate), locale);
                return {
                    start: start,
                    end: end
                };
            }
        case (0, $bCd2g.DateRangeScale).QUARTER:
            {
                const start = (0, $2uNcU.formatIsoLocalDate)((0, $cPLkE.default)(endDate), locale);
                const end = (0, $2uNcU.formatIsoLocalDate)((0, $5eayg.default)(endDate), locale);
                return {
                    start: start,
                    end: end
                };
            }
        default:
            return undefined;
    }
};
const $1d78840c165b0399$var$DateRangePickerContent = ({ withTimeScale: withTimeScale = true, defaultRangeScale: defaultRangeScale = (0, $bCd2g.DateRangeScale).MONTH, minDate: minDate, maxDate: maxDate, granularities: granularities, intervals: intervals, isRangeSelect: isRangeSelect, ...props })=>{
    const { value: date } = props;
    const { previousValue: previousDate } = props;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const locale = (0, $bCd2g.useDateLocale)();
    const availableGranularities = granularities ?? [
        ...$1d78840c165b0399$var$DEFAULT_GRANULARITIES
    ];
    const getInitialScale = ()=>{
        if (date) {
            const detectedScale = (0, $bCd2g.getDateRangeScale)(date);
            return availableGranularities.includes(detectedScale) ? detectedScale : availableGranularities[0];
        }
        return availableGranularities.includes(defaultRangeScale) ? defaultRangeScale : availableGranularities[0];
    };
    const isPreviousDateEnabled = (0, $dh538.fg)('mercury_web_daterangepicker_allow_prev_selection');
    const previousDateScale = previousDate && isPreviousDateEnabled ? (0, $bCd2g.getDateRangeScale)(previousDate) : undefined;
    const [scale, setScale] = (0, $42omo.useState)(getInitialScale());
    const onChange = (0, $42omo.useCallback)((newDate, selectedInterval)=>{
        if (newDate) props.onChange(newDate, scale, selectedInterval, (0, $b03a509836b96487$export$d19e7d63e5f456d1).DATE_SELECT);
    }, [
        props,
        scale
    ]);
    const onScaleChange = (0, $42omo.useCallback)((newScale)=>{
        setScale(newScale);
        if (date) {
            const newValue = $1d78840c165b0399$var$getDateValueForScale(date.end, newScale, locale);
            if (newValue) props.onChange(newValue, newScale, undefined, (0, $b03a509836b96487$export$d19e7d63e5f456d1).SCALE_SELECT);
        }
    }, [
        date,
        locale,
        props
    ]);
    const dateValue = date ? date.end : undefined;
    const previousDateValue = previousDate && isPreviousDateEnabled ? previousDate.end : undefined;
    const shouldShowGranularity = (granularity)=>availableGranularities.includes(granularity);
    const shouldShowSwitcher = withTimeScale && availableGranularities.length > 1;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $1d78840c165b0399$var$datePickerContentWrapperStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                testId: "date-picker-button-wrapper",
                role: "tablist",
                children: shouldShowSwitcher && /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                    xcss: $1d78840c165b0399$var$buttonGroupStyles,
                    children: [
                        shouldShowGranularity((0, $bCd2g.DateRangeScale).DAY) && /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            isSelected: scale === (0, $bCd2g.DateRangeScale).DAY,
                            onClick: ()=>onScaleChange((0, $bCd2g.DateRangeScale).DAY),
                            testId: "day-picker-button",
                            "aria-label": (0, $bCd2g.DateRangeScale).DAY,
                            "aria-selected": scale === (0, $bCd2g.DateRangeScale).DAY,
                            role: "tab",
                            children: formatMessage((0, $f8e55884fab2b31a$export$defe85febe8b728c).dayPickerButtonMessage)
                        }),
                        shouldShowGranularity((0, $bCd2g.DateRangeScale).MONTH) && /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            isSelected: scale === (0, $bCd2g.DateRangeScale).MONTH,
                            onClick: ()=>onScaleChange((0, $bCd2g.DateRangeScale).MONTH),
                            testId: "month-picker-button",
                            "aria-label": (0, $bCd2g.DateRangeScale).MONTH,
                            "aria-selected": scale === (0, $bCd2g.DateRangeScale).MONTH,
                            role: "tab",
                            children: formatMessage((0, $f8e55884fab2b31a$export$defe85febe8b728c).monthPickerButtonMessage)
                        }),
                        shouldShowGranularity((0, $bCd2g.DateRangeScale).QUARTER) && /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            isSelected: scale === (0, $bCd2g.DateRangeScale).QUARTER,
                            onClick: ()=>onScaleChange((0, $bCd2g.DateRangeScale).QUARTER),
                            testId: "quarter-picker-button",
                            "aria-label": (0, $bCd2g.DateRangeScale).QUARTER,
                            "aria-selected": scale === (0, $bCd2g.DateRangeScale).QUARTER,
                            role: "tab",
                            children: formatMessage((0, $f8e55884fab2b31a$export$defe85febe8b728c).quarterPickerButtonMessage)
                        }),
                        shouldShowGranularity((0, $bCd2g.DateRangeScale).INTERVAL) && /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            isSelected: scale === (0, $bCd2g.DateRangeScale).INTERVAL,
                            onClick: ()=>onScaleChange((0, $bCd2g.DateRangeScale).INTERVAL),
                            testId: "interval-picker-button",
                            "aria-label": (0, $bCd2g.DateRangeScale).INTERVAL,
                            "aria-selected": scale === (0, $bCd2g.DateRangeScale).INTERVAL,
                            role: "tab",
                            children: formatMessage((0, $f8e55884fab2b31a$export$defe85febe8b728c).intervalPickerButtonMessage)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                testId: "date-picker-content-wrapper",
                children: [
                    scale === (0, $bCd2g.DateRangeScale).DAY && /*#__PURE__*/ (0, $l998X.jsx)((0, $433bb48873b31cb1$export$97e6db89a86ff7ab), {
                        date: dateValue,
                        previousDate: previousDateScale === (0, $bCd2g.DateRangeScale).DAY ? previousDateValue : undefined,
                        onSelect: onChange,
                        minDate: minDate,
                        maxDate: maxDate
                    }),
                    scale === (0, $bCd2g.DateRangeScale).MONTH && /*#__PURE__*/ (0, $l998X.jsx)((0, $5df827cd4e9fb188$export$6e979f880d369f74), {
                        date: dateValue,
                        previousDate: previousDateScale === (0, $bCd2g.DateRangeScale).MONTH ? previousDateValue : undefined,
                        onSelect: onChange,
                        withTimeScale: withTimeScale,
                        minDate: minDate,
                        maxDate: maxDate
                    }),
                    scale === (0, $bCd2g.DateRangeScale).QUARTER && /*#__PURE__*/ (0, $l998X.jsx)((0, $1eae92c5ca3b6a84$export$1f3b9af4e880de43), {
                        date: dateValue,
                        previousDate: previousDateScale === (0, $bCd2g.DateRangeScale).QUARTER ? previousDateValue : undefined,
                        onSelect: onChange,
                        minDate: minDate,
                        maxDate: maxDate
                    }),
                    scale === (0, $bCd2g.DateRangeScale).INTERVAL && intervals && /*#__PURE__*/ (0, $l998X.jsx)((0, $3737d735d97a8978$export$e2c8a770d777dfd1), {
                        date: date,
                        onSelect: (newDate, selectedInterval)=>newDate && onChange(newDate, selectedInterval),
                        minDate: minDate,
                        maxDate: maxDate,
                        intervals: intervals,
                        isRangeSelect: isRangeSelect
                    })
                ]
            })
        ]
    });
};
var $1d78840c165b0399$export$2e2bcd8739ae039 = $1d78840c165b0399$var$DateRangePickerContent;





const $790e96c92f4eb91c$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    changeDateMessage: {
        id: "townsquare.date-range-picker.change-date-message",
        defaultMessage: "Generally, it's not the best practice to change the target date of a goal once it has been scored. If you do change this date, consider explaining why in your next update."
    },
    changeDateTooltipTitle: {
        id: "townsquare.date-range-picker.change-date-tooltip-title",
        defaultMessage: "Changing the target date?"
    },
    confirmButton: {
        id: "townsquare.date-range-picker.confirmation.confirm",
        defaultMessage: "Confirm"
    },
    cancelButton: {
        id: "townsquare.date-range-picker.confirmation.cancel",
        defaultMessage: "Cancel"
    }
});


const $75c8cfaa381f3d99$var$styles = {
    confirmationMessage: "_18zrv47k _85i5v47k",
    confirmButtons: "_18zrv47k _85i5v47k"
};
const $75c8cfaa381f3d99$export$17334619f3ac2224 = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const { value: value, defaultValue: defaultValue, onChange: onChange, placeholder: placeholder, onClose: onClose, withTimeScale: withTimeScale = true, appearance: appearance = 'default', disabled: disabled = false, minDate: minDate, maxDate: maxDate, granularities: granularities, intervals: intervals, showPlaceholderWithSubtleText: showPlaceholderWithSubtleText, intervalValue: intervalValue, selectIconPlacement: selectIconPlacement = 'end', size: size, isRangeSelect: isRangeSelect, confirmationMessage: confirmationMessage, displayConfirmationButtons: displayConfirmationButtons = false } = props;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isControlled = 'value' in props;
    const isBundledUpdatesEnabled = (0, $dh538.fg)('goal_types_m3_bundled_updates');
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const [currentValue, setCurentValue] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(value ?? defaultValue);
    const [selectedInterval, setSelectedInterval] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(intervalValue);
    const [pendingValue, setPendingValue] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(undefined);
    const locale = (0, $bCd2g.useDateLocale)();
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (isControlled && (0, $dh538.fg)('projects_ai_updates')) setCurentValue(value);
    }, [
        value,
        isControlled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if ((0, $dh538.fg)('mercury_web_enable_intervals')) {
            if (intervalValue) setCurentValue((0, $bCd2g.intervalToDatePickerValue)(intervalValue, intervalValue.startDate.getFullYear(), locale));
            setSelectedInterval(intervalValue);
        }
    }, [
        intervalValue,
        locale
    ]);
    const togglePopup = (0, $42omo.useCallback)(()=>{
        if (!disabled) {
            if (isOpen) onClose?.();
            setIsOpen(!isOpen);
        }
    }, [
        isOpen,
        onClose,
        disabled
    ]);
    const closePopup = (0, $42omo.useCallback)(()=>{
        setIsOpen(false);
        setPendingValue(undefined);
        onClose?.();
    }, [
        onClose
    ]);
    const onDateChange = (0, $42omo.useCallback)((newValue, confidence, newSelectedInterval, source)=>{
        if (source === (0, $b03a509836b96487$export$d19e7d63e5f456d1).SCALE_SELECT) return;
        if (isBundledUpdatesEnabled && displayConfirmationButtons && newValue && confidence) {
            setPendingValue({
                value: newValue,
                confidence: confidence,
                interval: newSelectedInterval
            });
            return;
        }
        setCurentValue(newValue);
        setSelectedInterval(newValue !== undefined ? newSelectedInterval : undefined);
        onChange(newValue, confidence, newSelectedInterval);
        setIsOpen(false);
        onClose?.();
    }, [
        onChange,
        onClose,
        displayConfirmationButtons,
        isBundledUpdatesEnabled
    ]);
    const onConfirm = (0, $42omo.useCallback)(()=>{
        if (!pendingValue) return;
        setCurentValue(pendingValue.value);
        setSelectedInterval(pendingValue.interval);
        onChange(pendingValue.value, pendingValue.confidence, pendingValue.interval);
        setIsOpen(false);
        setPendingValue(undefined);
        onClose?.();
    }, [
        pendingValue,
        onChange,
        onClose
    ]);
    const onClearDate = (0, $42omo.useCallback)(()=>{
        onDateChange();
    }, [
        onDateChange
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        zIndex: 610,
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1d78840c165b0399$export$2e2bcd8739ae039), {
                        value: value,
                        onChange: onDateChange,
                        withTimeScale: withTimeScale,
                        minDate: minDate,
                        maxDate: maxDate,
                        granularities: granularities,
                        intervals: intervals,
                        isRangeSelect: isRangeSelect
                    }, `${intervals?.length ?? 0}-${intervals?.[0]?.startDate.getTime() ?? ''}`),
                    isBundledUpdatesEnabled && displayConfirmationButtons && pendingValue && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                        children: [
                            confirmationMessage && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $75c8cfaa381f3d99$var$styles.confirmationMessage,
                                children: confirmationMessage
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $75c8cfaa381f3d99$var$styles.confirmButtons,
                                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                    space: "space.100",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                            appearance: "primary",
                                            onClick: onConfirm,
                                            children: formatMessage((0, $790e96c92f4eb91c$export$defe85febe8b728c).confirmButton)
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                            appearance: "subtle",
                                            onClick: closePopup,
                                            children: formatMessage((0, $790e96c92f4eb91c$export$defe85febe8b728c).cancelButton)
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
        isOpen: isOpen && !disabled,
        onClose: closePopup,
        shouldUseCaptureOnOutsideClick: true,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2ROAs.DateRange), {
                onClick: disabled ? undefined : togglePopup,
                value: currentValue,
                placeholder: placeholder,
                triggerProps: triggerProps,
                onClearDate: onClearDate,
                withTimeScale: withTimeScale,
                appearance: appearance,
                disabled: disabled,
                showPlaceholderWithSubtleText: showPlaceholderWithSubtleText,
                intervalDisplayName: selectedInterval?.name,
                selectIconPlacement: selectIconPlacement,
                size: size
            })
    });
});
module.exports["DateRangePicker"] = $75c8cfaa381f3d99$export$17334619f3ac2224;

});

parcelRegister("2ROAs", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-selectors  */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $ccHMk = parcelRequire("ccHMk");


var $8DN9t = parcelRequire("8DN9t");


var $ghftu = parcelRequire("ghftu");


var $dh538 = parcelRequire("dh538");


var $dcJ7R = parcelRequire("dcJ7R");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $jla7D = parcelRequire("jla7D");

const $fee56af2d8b1992b$var$wrapperStyles = null;
const $fee56af2d8b1992b$var$normalHeight = null;
const $fee56af2d8b1992b$var$reducedHeight = null;
const $fee56af2d8b1992b$var$dangerStyles = null; /**
                            * These styles replicate the styling of the DatePicker component which doesn't support fuzzy date selection.
                            */ 
const $fee56af2d8b1992b$var$selectBaseStyles = null;
const $fee56af2d8b1992b$var$focusRingVariantStyles = null;
const $fee56af2d8b1992b$var$normalBorderVariantStyles = null;
const $fee56af2d8b1992b$var$nonClickableWrapperStyles = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    blockSize: 'min-content',
    width: 'max-content',
    height: '32px',
    paddingInlineStart: 'space.075',
    paddingInlineEnd: 'space.150',
    backgroundColor: 'color.background.neutral',
    borderRadius: "var(--ds-radius-small, 4px)"
});
const $fee56af2d8b1992b$export$829bd850c745b6e = (props)=>{
    const { onClick: onClick, triggerProps: triggerProps = {}, placeholder: placeholder, value: value, withTimeScale: withTimeScale, appearance: appearance, showIcon: showIcon = true, showPlaceholderWithSubtleText: showPlaceholderWithSubtleText, size: size, intervalDisplayName: intervalDisplayName, dateLabel: dateLabelOverride, selectIconPlacement: selectIconPlacement = 'end', forceShowFocusRing: forceShowFocusRing = false } = props;
    const computedDateLabel = (0, $jla7D.useDateLabel)({
        value: value,
        placeholder: placeholder,
        withTimeScale: withTimeScale,
        intervalDisplayName: intervalDisplayName
    });
    const dateLabel = dateLabelOverride ?? computedDateLabel;
    const textColor = showPlaceholderWithSubtleText && !value ? 'color.text.subtlest' : 'color.text.subtle';
    const isBundledUpdatesEnabled = (0, $dh538.fg)('goal_types_m3_bundled_updates');
    const isDanger = isBundledUpdatesEnabled && appearance === 'danger';
    const isSelect = appearance === 'select';
    const { iconBefore: iconBefore, iconAfter: iconAfter } = (0, $42omo.useMemo)(()=>{
        if (!isSelect) return {
            iconBefore: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))), {
                    label: "calendar icon",
                    color: isDanger ? "var(--ds-icon-danger, #C9372C)" : undefined
                }),
            iconAfter: showIcon ? ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: "",
                    size: "small"
                }) : undefined
        };
        if (selectIconPlacement === 'start') return {
            iconBefore: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))), {
                    label: "",
                    color: isDanger ? "var(--ds-icon-danger, #C9372C)" : undefined
                })
        };
        if (!showIcon || selectIconPlacement !== 'end') return {
            iconBefore: undefined
        };
        return {
            iconBefore: undefined,
            iconAfter: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))), {
                    label: ""
                })
        };
    }, [
        isSelect,
        selectIconPlacement,
        showIcon,
        isDanger
    ]);
    if (!onClick) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
        alignBlock: "center",
        space: "space.025",
        xcss: $fee56af2d8b1992b$var$nonClickableWrapperStyles,
        testId: "date-range-trigger-wrapper",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))), {
                color: "currentColor",
                spacing: "spacious",
                label: "calendar icon"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                weight: "medium",
                color: textColor,
                children: dateLabel
            })
        ]
    });
    const showReducedHeight = size !== 'medium';
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": "date-range-trigger-wrapper",
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1osq _y3gn1e5h",
            showReducedHeight ? "_1n9hze3t _el891wug _1fsj1e5h _11rc1h6o" : "_1n9hze3t _15imzwfg _el891wug _1fsj1e5h",
            isSelect && "_1rfze4h9 _1symnqa1 _el891jfw _11rc1h6o _e4p51j9a _1rjeglyw _1w8o1r31 _akbaglyw _fquv1o36 _1r261v1w _8rmkxp8v _18ucl4ek _1a8p1j9a",
            isSelect && forceShowFocusRing ? "_y1hj1r31 _1hleglyw _1vk01o36 _1ejn1v1w _2a40xp8v" : "_1ejnrsbi",
            isDanger && "_1ejn1bqt _1rfze4h9 _1symnqa1 _uq4s1tmw _18uc1yvi"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
            ...triggerProps,
            shouldFitContainer: true,
            onClick: onClick,
            iconBefore: iconBefore,
            iconAfter: iconAfter,
            testId: "date-range-trigger",
            children: isSelect ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                weight: 'regular',
                color: textColor,
                children: dateLabel
            }) : showPlaceholderWithSubtleText ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                color: isDanger ? 'color.text.danger' : textColor,
                children: dateLabel
            }) : dateLabel
        })
    });
};
module.exports["DateRange"] = $fee56af2d8b1992b$export$829bd850c745b6e;

});

parcelRegister("jla7D", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $bCd2g = parcelRequire("bCd2g");




const $65320485ba76f83b$var$_default_1 = (0, $aXWIB.defineMessages)({
    noDateSet: {
        id: "date-range-picker.date-range.no-date-set",
        defaultMessage: "No date set"
    },
    fiscalYearPrefix: {
        id: "date-range-picker.date-range.fiscal-year-prefix",
        defaultMessage: "FY"
    }
});
var $65320485ba76f83b$export$2e2bcd8739ae039 = $65320485ba76f83b$var$_default_1;


const $c42567f1ebdad288$export$817f035fae319df = ({ value: date, placeholder: placeholder, withTimeScale: withTimeScale, intervalDisplayName: intervalDisplayName })=>{
    const intl = (0, $aXWIB.useIntl)();
    const locale = (0, $bCd2g.useDateLocale)();
    const noDateSelectedMessage = placeholder ? placeholder : intl.formatMessage((0, $65320485ba76f83b$export$2e2bcd8739ae039).noDateSet);
    const fiscalYearPrefix = intervalDisplayName !== undefined ? intl.formatMessage((0, $65320485ba76f83b$export$2e2bcd8739ae039).fiscalYearPrefix) : undefined;
    const dateLabel = date ? (0, $bCd2g.renderDateString)(locale, date, placeholder, withTimeScale, intervalDisplayName, fiscalYearPrefix) ?? noDateSelectedMessage : noDateSelectedMessage;
    return dateLabel;
};
module.exports["useDateLabel"] = $c42567f1ebdad288$export$817f035fae319df;

});

parcelRegister("4pirX", function(module, exports) {

var $2bMRn = parcelRequire("2bMRn");


var $78I9e = parcelRequire("78I9e");


var $dWCFT = parcelRequire("dWCFT");


var $eTlxX = parcelRequire("eTlxX");


var $bxYwf = parcelRequire("bxYwf");


var $bJbIe = parcelRequire("bJbIe");


var $hFGHP = parcelRequire("hFGHP");


var $ghphD = parcelRequire("ghphD");

const $aa713b87859aa9e1$var$DEFAULT_DATE_FNS_OPTIONS = {
    weekStartsOn: 1
};
// Wrap a date-fns method with default options param
// eslint-disable-next-line no-unused-vars
const $aa713b87859aa9e1$var$mixinDefaultOptions = (fn)=>{
    return function(...theArgs) {
        const lastIndex = fn.length - 1;
        if (fn.length === theArgs.length) theArgs[lastIndex] = {
            ...$aa713b87859aa9e1$var$DEFAULT_DATE_FNS_OPTIONS,
            ...theArgs[lastIndex]
        };
        else theArgs[lastIndex] = $aa713b87859aa9e1$var$DEFAULT_DATE_FNS_OPTIONS;
        return fn.apply(this, theArgs);
    };
};
const $aa713b87859aa9e1$export$6ed034ce62348e4 = $aa713b87859aa9e1$var$mixinDefaultOptions((0, $2bMRn.default));
const $aa713b87859aa9e1$export$ef8b6d9133084f4e = $aa713b87859aa9e1$var$mixinDefaultOptions((0, $78I9e.default));
const $aa713b87859aa9e1$export$d9468344d3651243 = $aa713b87859aa9e1$var$mixinDefaultOptions((0, $dWCFT.default));
const $aa713b87859aa9e1$export$efe19b760242b2fc = $aa713b87859aa9e1$var$mixinDefaultOptions((0, $eTlxX.default));
const $aa713b87859aa9e1$export$6ea683876c36b8d2 = $aa713b87859aa9e1$var$mixinDefaultOptions((0, $bxYwf.default));
const $aa713b87859aa9e1$export$98e6a39c04603d36 = $aa713b87859aa9e1$var$mixinDefaultOptions((0, $bJbIe.default));
const $aa713b87859aa9e1$export$b04fdcda82decc6c = $aa713b87859aa9e1$var$mixinDefaultOptions((0, $hFGHP.default));
const $aa713b87859aa9e1$export$42c81a444fbfb5d4 = $aa713b87859aa9e1$var$mixinDefaultOptions((0, $ghphD.default));
module.exports["differenceInCalendarWeeks"] = $aa713b87859aa9e1$export$6ed034ce62348e4;
module.exports["format"] = $aa713b87859aa9e1$export$d9468344d3651243;
module.exports["isSameWeek"] = $aa713b87859aa9e1$export$6ea683876c36b8d2;
module.exports["parse"] = $aa713b87859aa9e1$export$98e6a39c04603d36;

});

parcelRegister("4jeQc", function(module, exports) {
const $c3bf00e6f248dd59$export$7eec4b04e46b2bbb = 'd';
const $c3bf00e6f248dd59$export$62bca61de2e93906 = 'd MMM';
const $c3bf00e6f248dd59$export$ab8da37e29943dac = 'd MMM yyyy';
const $c3bf00e6f248dd59$export$4eb9e1cb04482994 = 'd MMMM yyyy';
const $c3bf00e6f248dd59$export$995fc5e95216ff51 = 'MMMM';
const $c3bf00e6f248dd59$export$7aa8df5d3355fa4a = 'MMM';
const $c3bf00e6f248dd59$export$e8d0682eb7d102dc = 'MMM yyyy';
const $c3bf00e6f248dd59$export$f0cc54e1ef1d4992 = 'MMMM yyyy';
const $c3bf00e6f248dd59$export$776919ea04c83e30 = 'dd-MMM-yyyy';
const $c3bf00e6f248dd59$export$c6c89fea1560539e = 'd MMMM yyyy h:mm a';
const $c3bf00e6f248dd59$export$bbb765b7b56eaefb = 'yyyy-MM-dd';
const $c3bf00e6f248dd59$export$e1e67977af8d567 = 'HH:mm:ss';
const $c3bf00e6f248dd59$export$c8cdef0703935cfd = `${$c3bf00e6f248dd59$export$bbb765b7b56eaefb}'T'${$c3bf00e6f248dd59$export$e1e67977af8d567}`;
const $c3bf00e6f248dd59$export$9cdd86a0412967e3 = 'yyyy/MM/dd';
const $c3bf00e6f248dd59$export$8d4e01dc6271a4b = 'FY';
module.exports["SAME_MONTH_FORMAT"] = $c3bf00e6f248dd59$export$7eec4b04e46b2bbb;
module.exports["SAME_YEAR_FORMAT"] = $c3bf00e6f248dd59$export$62bca61de2e93906;
module.exports["DIFF_YEAR_FORMAT"] = $c3bf00e6f248dd59$export$ab8da37e29943dac;
module.exports["FULL_DATE_FORMAT"] = $c3bf00e6f248dd59$export$4eb9e1cb04482994;
module.exports["MONTH_ONLY_FORMAT"] = $c3bf00e6f248dd59$export$995fc5e95216ff51;
module.exports["MONTH_ONLY_FORMAT_SHORT"] = $c3bf00e6f248dd59$export$7aa8df5d3355fa4a;
module.exports["MONTH_ONLY_FORMAT_DIFF_YEAR"] = $c3bf00e6f248dd59$export$e8d0682eb7d102dc;
module.exports["MONTH_WITH_YEAR"] = $c3bf00e6f248dd59$export$f0cc54e1ef1d4992;
module.exports["FULL_NICE_FORMAT"] = $c3bf00e6f248dd59$export$776919ea04c83e30;
module.exports["NICE_DATE_TIME"] = $c3bf00e6f248dd59$export$c6c89fea1560539e;
module.exports["ISO_LOCAL_DATE"] = $c3bf00e6f248dd59$export$bbb765b7b56eaefb;
module.exports["ISO_LOCAL_DATE_TIME"] = $c3bf00e6f248dd59$export$c8cdef0703935cfd;
module.exports["ISO_LOCAL_DATE_WITH_SLASHES"] = $c3bf00e6f248dd59$export$9cdd86a0412967e3;

});

parcelRegister("5UrJe", function(module, exports) {

var $bJbIe = parcelRequire("bJbIe");


var $da71s = parcelRequire("da71s");


var $4jeQc = parcelRequire("4jeQc");


var $4pirX = parcelRequire("4pirX");

const $4a83d265a060e753$export$e624d7c6c4ee7adb = (dateString, defaultValue, timezoneOffset)=>{
    if (dateString) {
        let date = (0, $4pirX.parse)(dateString, (0, $4jeQc.ISO_LOCAL_DATE_TIME), defaultValue);
        // Used to shift dates back to UTC time (parse will automatically add the user's timezone to dates)
        if (date && timezoneOffset) date = new Date(date.valueOf() + timezoneOffset);
        if (!date || isNaN(date.getTime())) date = (0, $da71s.default)(dateString);
        if (!date || isNaN(date.getTime())) date = defaultValue;
        return date;
    } else return defaultValue;
};
function $4a83d265a060e753$export$6c38b421fc127069(value) {
    const datePart = value.slice(0, 10);
    return (0, $bJbIe.default)(datePart, (0, $4jeQc.ISO_LOCAL_DATE), new Date());
}
module.exports["parseIsoLocalDateTime"] = $4a83d265a060e753$export$e624d7c6c4ee7adb;
module.exports["parseValueToLocalDate"] = $4a83d265a060e753$export$6c38b421fc127069;

});

parcelRegister("hFGHP", function(module, exports) {
$parcel$export(module.exports, "default", () => $cdd7647e3eb636f5$export$2e2bcd8739ae039);

var $922yL = parcelRequire("922yL");


var $egXhZ = parcelRequire("egXhZ");


var $jZ39j = parcelRequire("jZ39j");


var $b5utg = parcelRequire("b5utg");


var $2h3f7 = parcelRequire("2h3f7");

function $cdd7647e3eb636f5$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $b5utg.default)(2, arguments);
    var defaultOptions = (0, $2h3f7.getDefaultOptions)();
    var weekStartsOn = (0, $jZ39j.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $egXhZ.default)(dirtyDate);
    var day = (0, $jZ39j.default)(dirtyDay);
    var currentDay = date.getDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var delta = 7 - weekStartsOn;
    var diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $922yL.default)(date, diff);
}

});


//# sourceMappingURL=ProfileCard.899ac015.js.map
